import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, signal, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SplitAreaSize, SplitGutterInteractionEvent } from 'angular-split';
import { Globals } from 'src/app/shared/globals/globals';
import { HeaderParametersValues } from 'src/app/shared/models/data/headerParametersValues.model';
import { RoundDigit } from 'src/app/shared/models/data/roundDigit.model';
import { SendItdcrActionType } from 'src/app/shared/models/data/sendItdcrRequest.model';
import { BackendService } from 'src/app/shared/services/backend/backend.service';
import { TeiasoftLoaderService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-loader.service';
import { TeiasoftModalService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-modal.service';
import { TeiasoftToasterService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-toaster.service';
import { TeiasoftOdataService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-odata.service';
import { UtilsService } from 'src/app/shared/services/utils/utils.service';
import { ActiveFilter, CalculatedCols, CustomIcoCol, GridColumn, GridConfiguration, MenuVoice, OdataGridInitialFilters } from 'src/app/shared/teiasoft-bucket/teiasoft-grid-odata/teiasoft-grid-odata.component';
import { TeiasoftModalReturnObject } from 'src/app/shared/teiasoft-bucket/teiasoft-modal/teiasoft-modal.component';
import { TTButton } from 'src/app/shared/teiasoft-bucket/teiasoft-toolbar/teiasoft-toolbar.component';
import { ClickedCell } from 'src/app/shared/teiasoft-bucket/teiasoft-grid/teiasoft-grid.component';
import { CustomerSpecialRequirement } from 'src/app/shared/models/data/enquiry.model';
import { parseGridActionEvent } from 'src/app/shared/utils/grid-event.utils';

@Component({
  selector: 'app-itdcr',
  templateUrl: './itdcr.component.html',
  styleUrl: './itdcr.component.scss'
})
export class ItdcrComponent implements OnInit, AfterViewInit {
  @Input() inputItdcrNo?: string;
  @Input() inputShowHistory?: boolean;
  @Input() inputEmbeddedMode: boolean = false;

  @Output() onBackClick = new EventEmitter<void>();

  @ViewChild('areaTopTable', { static: true }) areaTopTable!: ElementRef<HTMLDivElement>;
  @ViewChild('areaBottomTable', { static: true }) areaBottomTable!: ElementRef<HTMLDivElement>;
  @ViewChild('activeGrid', { read: ElementRef }) activeGridEl!: ElementRef<HTMLElement>;
  @ViewChild('toComeGrid', { read: ElementRef }) toComeGridEl!: ElementRef<HTMLElement>;

  activeBodyVh = 68;  // sensible defaults
  toComeBodyVh = 68;

  topSectionSize: number = 50;
  bottomSectionSize: number = 50;

  selectedItdcrNo: string = '';
  selectedItdcrNotes: string = '';

  activeODataUrl: string = "activeItdcrs";
  activeODataEntity: string = "VItdcr";
  toComeODataUrl: string = "toComeItdcrs";
  toComeODataEntity: string = "VItdcr";
  latestSentODataUrl: string = "latestSentItdcrs";
  latestSentODataEntity: string = "VItdcr";
  historyODataUrl: string = "itdcrsHistory";
  historyODataEntity: string = "VItdcrHistory";

  historyInitialFilters: OdataGridInitialFilters[] = [
  ];
  activeInitialFilters: OdataGridInitialFilters[] = [];
  toComeInitialFilters: OdataGridInitialFilters[] = [];
  latestSentInitialFilters: OdataGridInitialFilters[] = [];

  columnsToHide: string[] = [
    "Id",
    "MillId",
    "ItdcrMillId",
    "IsTechnicalRequest",
    "IsCostRequest",
    "IsDeliveryRequest",
    "SalesPersonUserId",
    "SalesOfficeId",
    "CurrentItdcrOfficeId",
    "ExcelUrl",
    "Notes",
    "NumberOfAttachments",
    "TotalWeightUom",
    "TotalLengthUom",
    "ProcessedItdcrOfficesId",
    "UnitSystem",
    "PreviousItdcrOfficeId"
  ];
  columnsToHideHistory: string[] = this.columnsToHide;
  roundDigitsForGrid: RoundDigit[] = new Array();
  dateOnlyColumns: string[] = [
    'duedate',
    'offervaliditydate',
    'customerrequestdate',
    'offersenttocustomerdate',
    'bookedorderdate',
    'itdcrduedate'
  ];



  buttonsList: TTButton[] = new Array();
  buttonsListBack: TTButton[] = new Array();
  gridConfiguration: GridConfiguration = new GridConfiguration();
  latestSentGridConfiguration: GridConfiguration = new GridConfiguration();
  historyGridConfiguration: GridConfiguration = new GridConfiguration();

  activeCustomIcoCols: CustomIcoCol[] = new Array();
  toComeCustomIcoCols: CustomIcoCol[] = new Array();
  latestSentCustomIcoCols: CustomIcoCol[] = new Array();
  historyCustomIcoCols: CustomIcoCol[] = new Array();


  calculatedCols: CalculatedCols[] = new Array();
  gridFilterable: boolean = false;
  clearFilters: boolean = false;
  showSettingsDialog: boolean = false;
  showSendItdcr: boolean = false;
  showAttachments: boolean = false;
  showVisualOverview: boolean = false;
  showTempNotes: boolean = false;
  showSpecialRequirements: boolean = false;
  refreshGridKey: number = 0;
  showHistory: boolean = false;
  showLatestSent: boolean = false;
  itdcrAllColumns: GridColumn[] = [];
  event: any;
  customerSpecialRequirements: CustomerSpecialRequirement[] = new Array();


  millMode = false; // this flag handle what to show based on Itdcr permission
  isDataFiltered: any;
  historyActiveFilters: ActiveFilter[] = [];
  headerParametersValues: HeaderParametersValues = {
    lengthUoms:
    {
      metricUoms: [
        {
          "uomCode": "m",
          "isDefault": true
        }
      ],
      imperialUoms: [
        {
          "uomCode": "ft",
          "isDefault": true
        }
      ]
    }
    ,
    totalWeightUoms:
    {
      metricUoms: [
        {
          "uomCode": "kg",
          "isDefault": true
        }
      ],
      imperialUoms: [
        {
          "uomCode": "lbs",
          "isDefault": true
        }
      ]
    }

  }


  constructor(public globals: Globals, private backendService: BackendService, private translate: TranslateService, private teiasoftModalService: TeiasoftModalService, private teiasoftLoader: TeiasoftLoaderService, private utils: UtilsService, private teiasoftToaster: TeiasoftToasterService, private activatedRoute: ActivatedRoute, private oDataService: TeiasoftOdataService) {

  }

  ngOnInit(): void {
    this.millMode = this.utils.isAuthorized('Global', 'Itdcr', null);
    this.gridConfiguration = this.checkUserConfiguration(this.gridConfiguration, 'ITDCR');
    this.latestSentGridConfiguration = this.checkUserConfiguration(this.latestSentGridConfiguration, 'ITDCR_LatestSent');
    this.historyGridConfiguration = this.checkUserConfiguration(this.historyGridConfiguration, 'ITDCR_History');
    this.buildButtonsListBack();
    this.applyNavigationContext();
    this.buildButtonsList();
    this.buildCustomIconGrid();
    this.getRoundDigits();
  }

  get showBackButton(): boolean {
    return this.inputEmbeddedMode;
  }

  private applyNavigationContext(): void {
    this.applyShowHistoryContext();
    this.applyItdcrNoFilterContext();
  }

  private applyItdcrNoFilterContext(): void {
    const itdcrNo = this.inputItdcrNo ?? this.activatedRoute.snapshot.queryParamMap.get('itdcrNo');
    if (!itdcrNo) return;

    const filter: OdataGridInitialFilters = {
      column: 'ItdcrNo',
      type: 'string',
      value: itdcrNo
    };

    this.activeInitialFilters = [filter];
    this.toComeInitialFilters = [filter];
    this.latestSentInitialFilters = [filter];
    this.historyInitialFilters = [filter];
    
    this.gridFilterable = !!filter.value;
    this.buildButtonsList();
  }

  private applyShowHistoryContext(): void {
    if (this.inputShowHistory !== undefined && this.inputShowHistory !== null) {
      this.showHistory = !!this.inputShowHistory;
      return;
    }

    const showHistoryParam = this.activatedRoute.snapshot.queryParamMap.get('history')
      ?? this.activatedRoute.snapshot.queryParamMap.get('showHistory');
    if (!showHistoryParam) return;

    const normalized = showHistoryParam.trim().toLowerCase();
    this.showHistory = ['1', 'true', 'yes', 'y', 'on'].includes(normalized);
  }

  ngAfterViewInit() {
    this.recalculateViewsHeight();
  }

  recalculateViewsHeight() {
    setTimeout(() => this.updateVhFromAreas(), 150);
  }


  onGetOdataEntity(allColumns: GridColumn[]) {
    this.itdcrAllColumns = new Array();
    this.itdcrAllColumns = allColumns;
  }

  getRoundDigits() {
    this.teiasoftLoader.start();
    this.utils.getRoundDigits().subscribe(res => {
      this.roundDigitsForGrid = new Array();
      this.roundDigitsForGrid = res.filter(x => x.section == 'Enquiries' && x.api == 'GetEnquiries');
    });
  }

  checkUserConfiguration(gridConfiguration: GridConfiguration, gridName: string) {
    gridConfiguration = new GridConfiguration();

    const userConfiguration = this.utils.getUserConfiguration();
    const savedConfiguration = userConfiguration.gridsConfigurations?.find(cfg => cfg.name === gridName);

    if (savedConfiguration) {
      gridConfiguration = this.cloneGridConfiguration(savedConfiguration);
      if (gridConfiguration.options && gridConfiguration.options.topSectionSize) {
        this.topSectionSize = gridConfiguration.options.topSectionSize;
        this.bottomSectionSize = gridConfiguration.options.bottomSectionSize;
      } else {
        gridConfiguration = new GridConfiguration();
        gridConfiguration.name = gridName;
        gridConfiguration.defaultFilterView = this.millMode ? 'millGetAll' : 'salesGetMy';
        gridConfiguration.options = {
          topSectionSize: this.topSectionSize,
          bottomSectionSize: this.bottomSectionSize
        };
      }
    } else {
      gridConfiguration.name = gridName;
      gridConfiguration.defaultFilterView = this.millMode ? 'millGetAll' : 'salesGetMy';
      gridConfiguration.options = {
        topSectionSize: this.topSectionSize,
        bottomSectionSize: this.bottomSectionSize
      };
    }

    gridConfiguration.defaultFilterView = this.millMode ? 'millGetAll' : 'salesGetMy'; // apply always and ignore stored grid congif default  filter view

    return gridConfiguration;
  }

  private cloneGridConfiguration(gridConfiguration?: GridConfiguration): GridConfiguration {
    if (!gridConfiguration) return new GridConfiguration();
    return JSON.parse(JSON.stringify(gridConfiguration));
  }

  buildButtonsList() {
    this.buttonsList = new Array();
    let _item: TTButton = new TTButton();

    if (this.millMode) {
      /* ALL */
      _item.disabled = false;
      _item.icon = '';
      _item.id = 0;
      _item.size = "";
      _item.text = "";
      _item.tooltip = "current";
      _item.action = "filter|millGetAll";
      _item.type = "toggle";
      _item.toggleText = 'current';
      _item.state = !this.showHistory && !this.showLatestSent ? 'pressed' : '';
      this.buttonsList.push(_item);

      /* LATEST SENT */
      _item = new TTButton();
      _item.disabled = false;
      _item.icon = '';
      _item.id = 1;
      _item.size = "";
      _item.text = "";
      _item.tooltip = "latestSent";
      _item.action = "show|LatestSent";
      _item.type = "toggle";
      _item.toggleText = 'latestSent';
      _item.state = this.showLatestSent ? 'pressed' : '';
      this.buttonsList.push(_item);

      /* HISTORY */
      _item = new TTButton();
      _item.disabled = false;
      _item.icon = '';
      _item.id = 3;
      _item.size = "";
      _item.text = "";
      _item.tooltip = "history";
      _item.action = "show|History";
      _item.type = "toggle";
      _item.toggleText = 'history';
      _item.state = this.showHistory ? 'pressed' : '';
      this.buttonsList.push(_item);

    }
    else {

      /* MINE */
      _item = new TTButton();
      _item.disabled = false;
      _item.icon = '';
      _item.id = 1;
      _item.size = "";
      _item.text = "";
      _item.tooltip = "my";
      _item.action = "filter|salesGetMy";
      _item.type = "toggle";
      _item.toggleText = 'my';
      _item.state = this.gridConfiguration.defaultFilterView == 'salesGetMy' && !this.showHistory ? 'pressed' : '';
      this.buttonsList.push(_item);

      /* OFFICE */
      _item = new TTButton();
      _item.disabled = false;
      _item.icon = '';
      _item.id = 2;
      _item.size = "";
      _item.text = "";
      _item.tooltip = "office";
      _item.action = "filter|salesGetOffice";
      _item.type = "toggle";
      _item.toggleText = 'office';
      _item.state = this.gridConfiguration.defaultFilterView == 'salesGetOffice' && !this.showHistory ? 'pressed' : '';
      this.buttonsList.push(_item);

      /* HISTORY */
      _item = new TTButton();
      _item.disabled = false;
      _item.icon = '';
      _item.id = 3;
      _item.size = "";
      _item.text = "";
      _item.tooltip = "history";
      _item.action = "show|History";
      _item.type = "toggle";
      _item.toggleText = 'history';
      _item.state = this.showHistory ? 'pressed' : '';
      this.buttonsList.push(_item);
    }

    /* SEPARATOR */
    _item = new TTButton();
    _item.disabled = false;
    _item.icon = '';
    _item.id = 10;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "";
    _item.action = "";
    _item.type = "separator";
    _item.state = '';
    this.buttonsList.push(_item);


    /* EDIT GRID */
    _item = new TTButton();
    _item.disabled = false;
    _item.icon = 'fal fa-wrench';
    _item.id = 11;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "editGrid";
    _item.action = "showSettingsGrid";
    _item.type = "";
    _item.state = '';
    this.buttonsList.push(_item);

    /* SHOW/HIDE FILTER */
    _item = new TTButton();
    _item.disabled = false;
    _item.icon = !this.gridFilterable ? 'fal fa-filter' : 'fal fa-filter-circle-xmark';
    _item.id = 12;
    _item.size = "";
    _item.text = "";
    _item.tooltip = !this.gridFilterable ? "showGridFilters" : "hideGridFilters";
    _item.action = !this.gridFilterable ? "showFilter" : "closeFilter";
    _item.type = '';
    _item.state = this.isDataFiltered ? 'pressed' : '';
    this.buttonsList.push(_item);

    /* CLEAR FILTERS */
    _item = new TTButton();
    _item.disabled = !this.gridFilterable ? true : false;
    _item.icon = 'fal fa-eraser';
    _item.id = 13;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "clearGridFilters";
    _item.action = "clearFilter";
    _item.type = "";
    _item.state = '';
    this.buttonsList.push(_item);

    if (this.showHistory) {
      /* EXCEL */
      _item = new TTButton();
      _item.disabled = this.utils.isAuthorized('Global', "ExportEnquiries", null) ? false : true;
      _item.icon = 'fal fa-file-download';
      _item.id = 14;
      _item.size = "";
      _item.text = "";
      _item.tooltip = "exportItdcr";
      _item.action = "export";
      _item.type = "";
      _item.state = '';
      this.buttonsList.push(_item);
    }


  }

  buildButtonsListBack() {
    this.buttonsListBack = new Array();

    let _item: TTButton = new TTButton();
    _item.disabled = false;
    _item.icon = 'fas fa-arrow-left';
    _item.id = 0;
    _item.size = "";
    _item.text = "back";
    _item.tooltip = "back";
    _item.action = "back";
    _item.type = "";
    _item.state = '';
    this.buttonsListBack.push(_item);
  }

  buildCustomIconGrid() {
    this.activeCustomIcoCols = new Array();

    /* OPEN ACTION */
    let _item: CustomIcoCol = new CustomIcoCol();
    _item.action = '';
    _item.icon = new Array();
    _item.icon = ['fal fa-ellipsis-h'];
    _item.tooltip = "grid.openEnqActions";
    _item.position = "start";
    _item.disabled = false;
    _item.isMenu = true;
    _item.menuVoices = new Array();

    let _voice: MenuVoice = new MenuVoice();

    if (this.millMode) {
      _voice = new MenuVoice();
      _voice.text = "itdcr.sendITDCR";
      _voice.action = "sendITDCR";
      _voice.icon = 'fal fa-share';
      _item.menuVoices.push(_voice);

      _voice = new MenuVoice();
      _voice.text = "itdcr.closeITDCR";
      _voice.action = "closeITDCR";
      _voice.icon = 'fal fa-thumbs-up';
      _item.menuVoices.push(_voice);

      _voice = new MenuVoice();
      _voice.text = "itdcr.rejectITDCR";
      _voice.action = "rejectITDCR";
      _voice.icon = 'fal fa-thumbs-down';
      _item.menuVoices.push(_voice);
    }


    if (!this.millMode) {
      _voice = new MenuVoice();
      _voice.text = "itdcr.sendITDCR";
      _voice.action = "sendITDCR";
      _voice.icon = 'fal fa-share';
      _item.menuVoices.push(_voice);

      _voice = new MenuVoice();
      _voice.text = "itdcr.cancelITDCR";
      _voice.action = "cancelITDCR";
      _voice.icon = 'fal fa-trash';
      _item.menuVoices.push(_voice);
    }

    this.activeCustomIcoCols.push(_item);


    /* EXCEL */
    _item = new CustomIcoCol();
    _item.action = "excel";
    _item.icon = new Array();
    _item.icon = ['fal fa-file-spreadsheet'];
    _item.tooltip = this.translate.instant("grid.viewExcel");
    _item.position = "start";
    _item.disabled = (row) => row["ExcelUrl"] == null || row["ExcelUrl"] == '';
    _item.isMenu = false;
    this.activeCustomIcoCols.push(_item);

    /* ATTACHMENTS */
    _item = new CustomIcoCol();
    _item.action = "attachments";
    _item.icon = new Array();
    _item.icon = ['fal fa-paperclip'];
    _item.getColor = (row: any) => this.hasAttachments(row) ? '#ff6600' : null;
    _item.tooltip = this.translate.instant("grid.attachments");
    _item.position = "start";
    _item.disabled = false;
    _item.isMenu = false;
    this.activeCustomIcoCols.push(_item);

    /* VISUAL OVERVIEW */
    _item = new CustomIcoCol();
    _item.action = "visualOverview";
    _item.icon = new Array();
    _item.icon = ['fal fa-diagram-project'];
    _item.tooltip = this.translate.instant("grid.visualOverview");
    _item.position = "start";
    _item.disabled = false;
    _item.isMenu = false;
    this.activeCustomIcoCols.push(_item);

    /* NOTES */
    _item = new CustomIcoCol();
    _item.action = "tempNotes";
    _item.icon = new Array();
    _item.icon = ['fal fa-message'];
    // _item.getIcon = (row: any) => {
    //   return this.hasTemporaryNotes(row) ? ['fal fa-message-exclamation'] : ['fal fa-message'];
    // };
    _item.getColor = (row: any) => this.hasTemporaryNotes(row) ? '#ff6600' : null;
    _item.tooltip = this.translate.instant("grid.notes");
    _item.position = "start";
    _item.disabled = false;
    _item.isMenu = false;
    this.activeCustomIcoCols.push(_item);

    /* HISTORY */
    _item = new CustomIcoCol();
    _item.action = "viewHistory";
    _item.icon = new Array();
    _item.icon = ['fal fa-history'];
    _item.tooltip = this.translate.instant("grid.history");
    _item.position = "start";
    _item.disabled = false;
    _item.isMenu = false;
    this.activeCustomIcoCols.push(_item);


    this.toComeCustomIcoCols = this.activeCustomIcoCols.map(col => {
      let copy = { ...col, menuVoices: [...(col.menuVoices || [])] };
      // filter sendITDCR menuVoices
      if (copy.isMenu && copy.menuVoices?.length) {
        copy.menuVoices = copy.menuVoices.filter(v => v.action !== "sendITDCR");
      }

      return copy;
    });

    this.latestSentCustomIcoCols = new Array();

    _item = new CustomIcoCol();
    _item.action = "reassignToMyOffice";
    _item.icon = ['fal fa-reply'];
    _item.tooltip = this.translate.instant("itdcr.reassignToMyOffice");
    _item.position = "start";
    _item.disabled = false;
    _item.isMenu = false;
    this.latestSentCustomIcoCols.push(_item);

    _item = new CustomIcoCol();
    _item.action = "excel";
    _item.icon = ['fal fa-file-spreadsheet'];
    _item.tooltip = this.translate.instant("grid.viewExcel");
    _item.position = "start";
    _item.disabled = (row) => row["ExcelUrl"] == null || row["ExcelUrl"] == '';
    _item.isMenu = false;
    this.latestSentCustomIcoCols.push(_item);

    _item = new CustomIcoCol();
    _item.action = "attachments";
    _item.icon = ['fal fa-paperclip'];
    _item.getColor = (row: any) => this.hasAttachments(row) ? '#ff6600' : null;
    _item.tooltip = this.translate.instant("grid.attachments");
    _item.position = "start";
    _item.disabled = false;
    _item.isMenu = false;
    this.latestSentCustomIcoCols.push(_item);

    _item = new CustomIcoCol();
    _item.action = "visualOverview";
    _item.icon = ['fal fa-diagram-project'];
    _item.tooltip = this.translate.instant("grid.visualOverview");
    _item.position = "start";
    _item.disabled = false;
    _item.isMenu = false;
    this.latestSentCustomIcoCols.push(_item);

    // _item = new CustomIcoCol();
    // _item.action = "tempNotes";
    // _item.icon = ['fal fa-message'];
    // _item.getColor = (row: any) => this.hasTemporaryNotes(row) ? '#ff6600' : null;
    // _item.tooltip = this.translate.instant("grid.notes");
    // _item.position = "start";
    // _item.disabled = false;
    // _item.isMenu = false;
    // this.latestSentCustomIcoCols.push(_item);

    _item = new CustomIcoCol();
    _item.action = "viewHistory";
    _item.icon = ['fal fa-history'];
    _item.tooltip = this.translate.instant("grid.history");
    _item.position = "start";
    _item.disabled = false;
    _item.isMenu = false;
    this.latestSentCustomIcoCols.push(_item);

    this.historyCustomIcoCols = this.toComeCustomIcoCols.filter(c => !!c.action && c.action != "tempNotes" && c.action != "viewHistory");

  }

  get isReadOnlyMode(): boolean {
    return this.showHistory || this.showLatestSent;
  }

  private hasTemporaryNotes(row: any): boolean {
    const temporaryNotes = row?.TemporaryNotes;
    if (typeof temporaryNotes == 'string') return temporaryNotes.trim().length > 0;
    if (Array.isArray(temporaryNotes)) return temporaryNotes.length > 0;
    return !!temporaryNotes;
  }

  private hasAttachments(row: any): boolean {
    return Number(row?.NumberOfAttachments ?? 0) > 0;
  }

  onActiveFiltersUpdate(activeFilters: ActiveFilter[]) {
    if (this.showHistory) {
      this.historyActiveFilters = [...activeFilters];
    }

    this.isDataFiltered = activeFilters.length > 0;
    this.buildButtonsList();
  }

  private switchToCurrentView(): void {
    this.showLatestSent = false;
    this.showHistory = false;
    this.refreshFullGrid();
    this.buildButtonsList();
  }

  private resetViewFilters(): void {
    this.clearFilters = true;
    setTimeout(() => { this.clearFilters = false }, 250);

    this.historyInitialFilters = new Array();
    this.activeInitialFilters = new Array();
    this.toComeInitialFilters = new Array();
    this.latestSentInitialFilters = new Array();
    this.historyActiveFilters = new Array();

    this.gridFilterable = false;
    this.isDataFiltered = false;
  }

  onBtnToolbarClick(btn: TTButton) {
    if (btn.action == 'back') {
      this.onBackClick.emit();
      return;
    }

    if (btn.action!.indexOf('filter') != -1) {
      let _temp: string[] = new Array();
      _temp = btn.action!.split("|");
      this.gridConfiguration.defaultFilterView = _temp[1];
      this.onUpdateConfiguration(this.gridConfiguration);

      this.showHistory = false;
      this.showLatestSent = false;
      this.resetViewFilters();
      this.refreshFullGrid();
      this.buildButtonsList();

    }
    if (btn.action!.indexOf('show') != -1) {
      let _temp: string[] = new Array();
      _temp = btn.action!.split("|");
      this.resetViewFilters();
      if (_temp[1] == 'History') {
        this.showHistory = true;
        this.showLatestSent = false;
        this.refreshFullGrid();
        this.buildButtonsList();
      }
      if (_temp[1] == 'LatestSent') {
        this.showLatestSent = true;
        this.showHistory = false;
        this.refreshFullGrid();
        this.buildButtonsList();
      }
    }

    if (btn.action == 'export') {
      this.exportHistoryItdcrs();
    }

    if (btn.action == 'export') {
      this.exportHistoryItdcrs();
    }

    /* SHOW SETTINGS */
    if (btn.action == 'showSettingsGrid') {
      this.showSettingsDialog = true;
    }

    /* SHOW FILTER */
    if (btn.action == 'showFilter') {
      this.gridFilterable = true;
      this.buildButtonsList();
      this.recalculateViewsHeight();
    }

    /* CLOSE FILTER */
    if (btn.action == 'closeFilter') {
      this.gridFilterable = false;
      this.buildButtonsList();
      this.recalculateViewsHeight();
    }

    if (btn.action == 'clearFilter') {
      this.clearFilters = true;
      setTimeout(() => { this.clearFilters = false }, 250);
      this.refreshFullGrid();
    }


  }

  private exportHistoryItdcrs() {
    this.teiasoftLoader.start();
    this.oDataService.exportToExcelByEndpoint(
      'odata/exportHistoryItdcrs/exportAll',
      this.historyActiveFilters,
      this.historyGridConfiguration.gridSortings!,
      'SubmissionDate desc'
    ).subscribe({
      next: (res) => {
        this.teiasoftLoader.stop();
        if (res && res["value"]) {
          window.open(res["value"], "_blank");
        }
      },
      error: () => {
        this.teiasoftLoader.stop();
      }
    });
  }

  customIconClick(evt: any) {

    if (evt.indexOf("|") != -1) {
      const { action: _action, row: _obj } = parseGridActionEvent(evt);

      if (_action == 'closeITDCR') {
        this.teiasoftModalService.show("confirm", "ITDCR", this.translate.instant('itdcr.confirmCloseItdcr'), _obj["ItdcrNo"], 'confirmCloseItdcr', false, undefined, undefined, 'itdcr');
      }

      if (_action == 'sendITDCR') {
        this.selectedItdcrNo = _obj["ItdcrNo"];
        this.showSendItdcr = true;
      }

      if (_action == 'reassignToMyOffice') {
        this.teiasoftModalService.show("confirm", "ITDCR", this.translate.instant('itdcr.confirmReassignToMyOffice'), _obj["ItdcrNo"], 'confirmReassignToMyOffice', false, undefined, undefined, 'itdcr');
      }

      if (_action == 'rejectITDCR') {
        this.teiasoftModalService.show("confirm", "ITDCR", this.translate.instant('itdcr.confirmRejectItdcr'), _obj["ItdcrNo"], 'confirmRejectItdcr', true, undefined, undefined, 'itdcr');
      }

      if (_action == 'cancelITDCR') {
        this.teiasoftModalService.show("confirm", "ITDCR", this.translate.instant('itdcr.confirmCancelItdcr'), _obj["ItdcrNo"], 'confirmCancelItdcr', false, undefined, undefined, 'itdcr');
      }

      if (_action == 'attachments') {
        this.selectedItdcrNo = _obj["ItdcrNo"];
        this.showAttachments = true;
      }

      if (_action == 'visualOverview') {
        this.selectedItdcrNo = _obj["ItdcrNo"];
        this.showVisualOverview = true;
      }

      if (_action == 'excel') {
        const url = _obj["ExcelUrl"];
        window.open(url, '_blank', 'noopener,noreferrer');
      }

      if (_action == 'tempNotes') {
        this.selectedItdcrNo = _obj["ItdcrNo"];
        this.selectedItdcrNotes = _obj["TemporaryNotes"];
        this.showTempNotes = true;
      }

      if (_action == 'viewHistory') {
        const EnquiryNo = _obj["EnquiryNo"];
        const Mill = _obj["Mill"];

        this.historyInitialFilters = new Array();
        this.historyInitialFilters.push(
          {
            column: 'EnquiryNo',
            type: 'string',
            value: EnquiryNo.slice(0, EnquiryNo.lastIndexOf("-")) // remove enquiry revion number
          },
          {
            column: 'Mill',
            type: 'string',
            value: Mill
          }
        );
        this.showLatestSent = false;
        this.showHistory = true;
        this.buildButtonsList(); // to show history action pushed
      }


    }

  }

  onCellClick(cell: ClickedCell) {
    if (cell.colName?.toLowerCase() != 'enquiryhascustomerspecialrequirements') return;

    const enquiryNo: string | undefined = cell.row?.["EnquiryNo"];
    if (!enquiryNo) return;

    this.backendService.getEnquiryCustomerSpecialRequirements(enquiryNo).subscribe(res => {
      this.customerSpecialRequirements = res.customerSpecialRequirements || new Array();
      this.showSpecialRequirements = true;
    });
  }

  /* MODAL CONFIRM */
  onConfirmModal(evt: TeiasoftModalReturnObject) {
    if (evt.closeFlag == 'confirmCloseItdcr') {
      const itdrcNo = evt.parameter;
      this.teiasoftLoader.start();
      this.backendService.closeItdcr(itdrcNo).subscribe((res) => {
        this.teiasoftLoader.stop();
        this.refreshFullGrid();
      }, (_err) => {
        this.refreshFullGrid();
      })
    }
    if (evt.closeFlag == 'confirmRejectItdcr') {
      const itdrcNo = evt.parameter;
      const notes = evt.notes || '';
      this.teiasoftLoader.start();
      this.backendService.rejectItdcr(itdrcNo, notes).subscribe((res) => {
        this.teiasoftLoader.stop();
        this.refreshFullGrid();
      }, (_err) => {
        this.refreshFullGrid();
      })
    }
    if (evt.closeFlag == 'confirmCancelItdcr') {
      const itdrcNo = evt.parameter;
      this.teiasoftLoader.start();
      this.backendService.cancelItdcr(itdrcNo).subscribe((res) => {
        this.teiasoftLoader.stop();
        this.refreshFullGrid();
      })
    }

    if (evt.closeFlag == 'confirmReassignToMyOffice') {
      const itdrcNo = evt.parameter;
      this.teiasoftLoader.start();
      this.backendService.sendItdcr(itdrcNo, {
        actionType: SendItdcrActionType.ToPreviousItdcrOffice,
        toNotes: ''
      }).subscribe((res) => {
        this.teiasoftLoader.stop();
        this.switchToCurrentView();
      }, (_err) => {
        this.teiasoftLoader.stop();
        this.refreshFullGrid();
      });
    }



  }

  refreshFullGrid() {
    this.refreshGridKey++;
    this.recalculateViewsHeight();
  }

  onSendItdcr() {
    this.showSendItdcr = false;
    this.refreshFullGrid();
  }

  onUpdateConfiguration(gridConfiguration: GridConfiguration) {
    this.utils.upsertGridConfiguration(gridConfiguration);
    this.gridConfiguration = this.cloneGridConfiguration(gridConfiguration);

    this.updateUserConfiguration();
  }

  onUpdateHistoryConfiguration(gridConfiguration: GridConfiguration) {
    this.utils.upsertGridConfiguration(gridConfiguration);
    this.historyGridConfiguration = this.cloneGridConfiguration(gridConfiguration);

    this.updateUserConfiguration();
  }

  onUpdateLatestSentConfiguration(gridConfiguration: GridConfiguration) {
    this.utils.upsertGridConfiguration(gridConfiguration);
    this.latestSentGridConfiguration = this.cloneGridConfiguration(gridConfiguration);

    this.refreshFullGrid(); // to apply new configuration (sorting, columns order, etc..)

    this.updateUserConfiguration();
  }


  updateUserConfiguration() {
    this.backendService.updateUserConfiguration(this.globals.userLogged!.configuration!, this.globals.userLogged!.language!, this.globals.userLogged!.dateFormat!).subscribe(res => {
      localStorage.setItem("userLogged", JSON.stringify(this.globals.userLogged!));
    });
  }


  onSplitChanged(event: SplitGutterInteractionEvent) {
    this.updateVhFromAreas();
    this.storeAreaConfiguration(event.sizes);
  }

  storeAreaConfiguration(sizes: SplitAreaSize[]) {
    this.gridConfiguration.options = {
      ...(this.gridConfiguration.options ?? {}),
      topSectionSize: sizes[0],
      bottomSectionSize: sizes[1]
    }
    this.onUpdateConfiguration(this.gridConfiguration);
  }

  onCloseAttachments() {
    this.showAttachments = false;
    this.selectedItdcrNo = '';
    this.refreshFullGrid();
  }


  onSaveNotes(notes: string) {

    const onCompleteCallback = () => {
      this.showTempNotes = false;
      this.selectedItdcrNo = '';
      this.selectedItdcrNotes = '';
    };

    this.backendService.setItdcrTemporaryNotes(this.selectedItdcrNo, notes).subscribe((res) => {
      this.teiasoftToaster.show("success", this.translate.instant("commons.success"));
      this.refreshFullGrid();
    }, onCompleteCallback, onCompleteCallback)
  }

  private updateVhFromAreas() {
    this.activeBodyVh = this.computeBodyVh(
      this.areaTopTable.nativeElement,
      this.activeGridEl?.nativeElement
    );
    this.toComeBodyVh = this.computeBodyVh(
      this.areaBottomTable.nativeElement,
      this.toComeGridEl?.nativeElement
    );
  }


  private computeBodyVh(areaEl: HTMLElement, gridHost?: HTMLElement): number {
    const toVh = (px: number) => (px / window.innerHeight) * 100;

    const areaPx = areaEl?.clientHeight ?? 0;

    // Look up grid internals from the host element
    // Header (includes filters), footer; both are present only when grid is loaded
    let headerPx = 0;
    let footerPx = 0;

    if (gridHost) {
      const header = gridHost.querySelector<HTMLElement>('.tg-header.tgodata-header');
      const footer = gridHost.parentElement?.querySelector<HTMLElement>('.tg-footer')   // footer is outside inner teiasoft-grid?
        ?? gridHost.querySelector<HTMLElement>('.tg-footer');                 // fallback if inside

      headerPx = header?.offsetHeight ?? 0;
      footerPx = footer?.offsetHeight ?? 0;
    }

    // Available space for .tg-body-cnt 
    // add extra 12px
    const bodyPx = Math.max(0, areaPx - headerPx - footerPx - 12);

    return toVh(bodyPx);
  }
}
